module.exports = __webpack_public_path__ + "images/accents/accent-strawberries@1x-b459deb9ab278523d1419d8b5473e5e7.webp";